const LibraryFactory = require('../library').instance;
const DesignFacade = require('../../facade/design/design');
const advice = require('../../utils/advice');

function LibraryPopulator () {
  this.canvas = null;
  this.fileContentUploader = null;
  this.type = null;
  this.libraryFactory = LibraryFactory;

  this.handlers = {
    text: require('./populator/text'),
    image: require('./populator/image'),
    logo: require('./populator/logo'),
    icon: require('./populator/icon'),
    color: require('./populator/color'),
    video: require('./populator/video')
  };
}

LibraryPopulator.prototype = _.extend({}, Backbone.Events);

LibraryPopulator.prototype.initialize = function (canvas) {
  this.canvas = canvas;

  _.bindAll(this,
    'onError',
    'wrappResource',
    'addElementToLibrary',
    'setLibrary',
    'resetLibrary'
  );
};

LibraryPopulator.prototype.setLibrary = function (library) {
  this.libraryFactory = library;
};

LibraryPopulator.prototype.resetLibrary = function () {
  this.libraryFactory = LibraryFactory;
};

LibraryPopulator.prototype.addElementToLibrary = function (element, customType, forceLibraryReset = false) {
  INKIVE.Modal.togglePageLoader(true);

  this.generateLibraryItem(element, customType).then(
    _.bind(postLibraryItem, this),
    this.onError
  );

  function postLibraryItem (type, item) {
    this.libraryFactory.post(type, item).then(
      _.bind(onItemAdded, this, type),
      this.onError
    );
  }

  function onItemAdded (type, model) {
    this.libraryFactory.clearModelCache();
    forceLibraryReset && this.resetLibrary();
    this.trigger(`new.${type}`, model.attributes);
    INKIVE.Modal.togglePageLoader(false);
    advice.show('add-to-library-success');
  }
};

LibraryPopulator.prototype.onError = function (errorMessage) {
  INKIVE.Modal.togglePageLoader(false);
  advice.show(_.isString(errorMessage) ? errorMessage : 'add-to-library-error');
};

LibraryPopulator.prototype.generateLibraryItem = function (element, customType) {
  const deferred = $.Deferred();
  const data = DesignFacade.get($(element).is('.background') ? 'background' : element.getAttribute('id'));

  let handlerType = customType;
  if (!handlerType) {
    handlerType = _.contains(['sticker', 'group', 'shape'], data.type) ? 'icon' : data.type;
  }
  const handler = this.handlers[handlerType];

  if (handler) {
    element.setAttribute('from-library', 'true'); // Why are we setting attributes here instead of facade?
    const canvas = INKIVE.Tool.INSTANCE.editor.canvas;
    canvas.clearSelection();
    canvas.selectOnly([element]);

    handler.getNewItem(data, element)
      .then(_.bind(this.ensureUniquenes, this, handlerType), deferred.reject)
      .then(this.wrappResource, _.partial(deferred.reject, 'add-to-library-duplicity'))
      .then(_.partial(deferred.resolve, handlerType + 's'));
  } else {
    deferred.reject(new Error('generateLibraryItem error: No handler for type ' + handlerType));
  }

  return deferred.promise();
};

LibraryPopulator.prototype.ensureUniquenes = function (handlerType, newItemData) {
  const isSame = _.partial(this.handlers[handlerType].isSameModel, newItemData);
  const deferred = $.Deferred();

  this.libraryFactory.get(handlerType + 's').then(function (items) {
    _.any(_.pluck(items, 'data'), isSame)
      ? deferred.reject(new Error(`ensureUniquenes failed for ${handlerType}`))
      : deferred.resolve(handlerType, newItemData);
  });

  return deferred.promise();
};

LibraryPopulator.prototype.wrappResource = function (handlerType, newItemData) {
  return {
    type: handlerType.charAt(0).toUpperCase() + handlerType.slice(1),
    // folder : this.libraryFactory.currentFolderId, // TODO
    data: newItemData
  };
};

module.exports = new LibraryPopulator();
